import { ScrollView, useWindowDimensions, View } from 'react-native';
import { styles } from './SingleRowToolOptions.styles';
import { ToolOptionsRendererProps } from '../../../BaseToolbar.types';
import { useToolOptionsRendererLogic } from '../ToolOptionsRenderer.logic';
import { ToolOptionsProps } from '../ToolOptionsRenderer.types';
import { observer } from 'mobx-react-lite';
import { StepCard } from 'src/editor-v3/components/step-card/StepCard';
import { useCallback } from 'react';
import { neutrals } from 'src/theme/colors';
import { useStore } from 'src/contexts/StoreContext';
import { getFormattedPrice } from 'src/helpers/price.helper';

export const SingleRowToolOptions = observer((props: ToolOptionsRendererProps<ToolOptionsProps>) => {
  const { options, isActive, isPriceVisible } = props;
  const { scrollViewRef, getScrollViewElementTestId, isOptionSelected, onPressAndSelectToolOption } =
    useToolOptionsRendererLogic(props as ToolOptionsRendererProps<ToolOptionsProps>);
  const { i18n } = useStore();
  const { width } = useWindowDimensions();
  const widthSize = width * 0.1 <= 150 ? width * 0.1 : 150;

  const renderItem = useCallback(
    ({ item, index }: { item: ToolOptionsProps; index: number }) => ({
      code: item.productOptionChoiceCode,
      previewImageUrl: item?.previewImageUrl || '',
      title: i18n.t(item.titleKey),
      price: isPriceVisible ? getFormattedPrice({ price: item.price }) : undefined,
      index,
      isActive: isActive,
      isSelected: isOptionSelected(item),
      isDisabled: !item?.enabled,
      isSuggested: false,
      width: widthSize,
      borderColor: neutrals.neutralGrays.dust,
      onPress: () => onPressAndSelectToolOption(item),
      isSuboptimal: item.isSuboptimal,
    }),
    [options, isOptionSelected, onPressAndSelectToolOption, isPriceVisible],
  );

  return (
    <ScrollView contentContainerStyle={styles.contentContainer} ref={scrollViewRef} horizontal>
      {options.map((item: ToolOptionsProps, index: number) => {
        const props = renderItem({ item, index });
        return (
          <View key={item.productOptionChoiceCode} testID={getScrollViewElementTestId(index)}>
            <StepCard {...props} />
          </View>
        );
      })}
    </ScrollView>
  );
});

SingleRowToolOptions.displayName = 'SingleRowToolOptions';
